var productList = (function ($) {
  "use strict";

  var jsonBusiness;
  var jsonHome;
  var pageLanguage = urlControl.getURLParameter("lang") || "en";
  var $productList = $("#product-list");

  var getCurrentPageCategory = function () {
    return "home";
  };

  var loadSupportedLanguages = function (combinedJson, selectedLang) {
    var pageLang = selectedLang || pageLanguage;
    var combineList = jsonUtility.getAllLanguages(combinedJson);
    var menuItems = "";
    $.each(combineList, function (index, language) {
      var url =
        window.location.pathname +
        urlControl.getURLSymbol() +
        "lang=" +
        language.code;
      var selected = "";
      if (pageLang === language.code) {
        omni.languageMenus.setCurrentValue(
          omni.localizeLanguage(language.code, language.name)
        );
        selected = "class='selected'";
      }
      menuItems +=
        "<li " +
        selected +
        "><a href='" +
        url +
        "' data-code='" +
        language.code +
        "'>" +
        omni.localizeLanguage(language.code, language.name) +
        "</a></li>";
    });
    omni.languageMenus.addMenuItems($(menuItems));
  };

  var checkLanguageAvailability = function (json, path, version) {
    var product = _(json).findWhere({
      path: path,
    });

    if (product === undefined) {
      return false;
    }

    var productVersion = _(product.versions).findWhere({
      number: version,
    });

    if (productVersion === undefined) {
      return false;
    }

    var productLanguage = _(productVersion.language).where({
      code: pageLanguage,
    });
    return productLanguage.length ? true : false;
  };

  var languageUnsupportedAlert = function () {
    var $alert = $("<span>")
      .attr("aria-hidden", "true")
      .addClass("lang-alert fsg-icon icon-status-warning")
      .attr("data-localize", "unsupportedLanguage");
    $alert.tooltip({
      title: "This product guide is not available in your selected language",
      trigger: "hover",
      template:
        "<div class='tooltip tooltip-warning'><div class='tooltip-arrow'></div><div class='tooltip-inner'></div></div>",
    });
    return $alert;
  };

  var setPlatformsSelector = function (
    productsJson,
    productCategory,
    currentVersion,
    productGroup,
    platformProp,
    pPlatformIcon
  ) {
    function setMenuItem(platformName, platformIcon, path) {
      var url =
        "product.html" +
        urlControl.getURLSymbol() +
        productCategory +
        "/" +
        path +
        "/latest/" +
        pageLanguage;
      var $menuItem = $(
        "<li><a href='" +
          url +
          "'><img src='img/os/os-" +
          platformIcon +
          ".svg'><span>" +
          platformName +
          "</span></a></li>"
      );

      if (!checkLanguageAvailability(productsJson, path, currentVersion)) {
        url =
          "product.html" +
          urlControl.getURLSymbol() +
          productCategory +
          "/" +
          path +
          "/latest/en/";
        $menuItem.children("a").attr("href", url);
        $menuItem.append(languageUnsupportedAlert());
      }

      $menuItem.on("click", function (e) {
        e.preventDefault();
        window.location.href = url;
      });

      return $menuItem;
    }

    function setPlatforms(product) {
      if (product.platform) {
        var platformName = product.platform.name;
        var platformIcon = product.platform.icon || null;

        var sorted = _(product.versions)
          .sortBy(function (obj) {
            return parseFloat(obj.number);
          })
          .reverse();
        var thisProductLatestVersion = sorted[0].number;

        if (thisProductLatestVersion === currentVersion) {
          //currentVersion is the display product latest version
          $menuItems.append(
            setMenuItem(platformName, platformIcon, product.path)
          );
        }
      }
    }

    var $menuItems = $("<ul class='platform-list'>");

    if (productGroup && platformProp) {
      var products = _.chain(productsJson)
        .where({
          group: productGroup,
        })
        .sortBy(function (productObj) {
          return productObj.platform ? productObj.platform.name : null;
        });
      _(products).each(setPlatforms); //get multiple menu items
    } else {
      return $("");
    }
    return $menuItems;
  };

  var loadProducts = (function ($) {
    var json;
    var productCategory;
    var defProductColumnClasses = "product col-xs-12 col-sm-6 col-md-4 ";
    var productColumnClasses = defProductColumnClasses;
    var productHeroColumnClasses =
      "product product-hero col-xs-12 col-sm-6 col-md-6 ";

    function addGuideOptionsOrURL(guidesOptions, $object, url) {
      $object.on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();

        if (guidesOptions !== "") {
          var $parent = $(this).parents(".product");
          $parent.addClass("active");

          $productList.find(".platform-list").removeClass("unhide");
          var $platformList = $parent.children(".platform-list");
          $platformList.addClass("unhide");
          utility.equalHeight($platformList.children("li"));

          $("html").one("click", function (e) {
            $platformList.removeClass("unhide");
            $parent.removeClass("active");
          });

          if ("ontouchstart" in document.documentElement) {
            //to dismiss list in mobile (ios esp)
            $("html").off("click"); //unbind html click
            $("<div>")
              .addClass("dropdown-backdrop")
              .insertBefore($platformList)
              .one("click", function (e) {
                $platformList.removeClass("unhide");
                $parent.removeClass("active");
                $(this).remove();
              });
          }
        } else {
          window.location.assign(url);
        }
      });
    }

    function productColumn(product, index) {
      var latestVersion = product.versions[product.versions.length - 1].number;
      var url =
        "product.html" +
        urlControl.getURLSymbol() +
        productCategory +
        "/" +
        product.path +
        "/" +
        latestVersion +
        "/" +
        pageLanguage;
      var $supportedPlatforms = setPlatformsSelector(
        json,
        productCategory,
        latestVersion,
        product.group,
        product.platform
      );
      var columnClasses =
        productCategory === "home" && index < 2
          ? productHeroColumnClasses
          : productColumnClasses;
      var guideOptions = $supportedPlatforms.children().length
        ? "guide-options"
        : "";

      var iconFolder = "img/products/";
      var $productImg = $(
        "<div class='middle-align'><img class='product-img' src='" +
          iconFolder +
          product.path +
          ".svg' onerror=\"this.src='img/products/" +
          product.path +
          ".png';this.onerror='null'\"></div>"
      );
      var $title = $("<div class='product-title'>").text(product.name);

      if (!checkLanguageAvailability(json, product.path, latestVersion)) {
        url =
          "product.html" +
          urlControl.getURLSymbol() +
          productCategory +
          "/" +
          product.path +
          "/" +
          latestVersion +
          "/en/";
        $title.append(languageUnsupportedAlert());
      }

      if ($supportedPlatforms.find("a").length > 1) {
        var locViewStr =
          localizePage.getLocalizedString("common:view") || "View Guide"; //grab string from cached
        if (guideOptions !== "" && $supportedPlatforms.find("a").length > 1) {
          var $link = $(
            "<span data-localize='view' class='" +
              guideOptions +
              "' href='" +
              url +
              "'>"
          ).text(locViewStr); //data attr as backup if loc file not yet cached
        } else {
          guideOptions = "";
          var $link = $(
            "<a data-localize='view' class='" +
              guideOptions +
              "' href='" +
              url +
              "'>"
          ).text(locViewStr);
          $supportedPlatforms = "";
        }
        addGuideOptionsOrURL(guideOptions, $link, url);
      }

      addGuideOptionsOrURL(guideOptions, $productImg.children("img"), url);

      var $productColumn = $("<div class='" + columnClasses + "'>").append(
        $productImg,
        $productInfo
      );

      $productColumn.append($supportedPlatforms);

      return $productColumn;
    }

    function productRow(suite) {
      var prodList;
      var hookName = suite.refID === 0 ? "suiteOther" : "";
      var $row = $("<div>").addClass(
        "row product-container collapsible collapsed"
      );
      var $suiteTitle = !suite.hideName
        ? $("<div>")
            .attr("data-localize", hookName)
            .addClass("product-suite-title collapsible-header border-top")
            .text(suite.name)
        : $("");
      var $content = $("<div>").addClass(
        "collapsible-content border-top clearfix m-b-4"
      );

      $suiteTitle.on("click", function (e) {
        $(this).toggleClass("hide-suite");
        $(this).parent().find(".collapsible-content").toggle();
      });

      $row.append($suiteTitle);

      // refID = 0 is only for Other products
      if (suite.refID === 0) {
        prodList = _(json).filter(function (obj) {
          return !obj.isSuite && (!obj.suiteID || obj.suiteID === 0);
        });
      } else {
        prodList = _(json).filter(function (obj) {
          return _.contains(obj.suiteID, suite.refID);
        });
      }

      prodList = _(prodList).reject(function (obj) {
        return obj.visibility && obj.visibility.hideInHome === true;
      });

      prodList = _(prodList).sortBy("order");

      var $columns = _(prodList).map(productColumn);
      $content.append($("<div class='line-hider'>"));
      $content.append($columns);
      return $row.append($content);
    }

    function equalHeight() {
      var delay = setTimeout(function () {
        utility.equalHeight($(".product-hero"));
        utility.equalHeight($(".product:not(.product-hero)"));
        clearTimeout(delay);
      }, 500);
    }

    function setJson(newJson) {
      // for unit test purpose
      json = newJson;
    }

    function createList(prodJson, prodCategory) {
      json = prodJson;
      productCategory = prodCategory;
      productColumnClasses = defProductColumnClasses;

      var suites = _(json).where({ isSuite: true });
      var $rows = suites.map(productRow);

      $productList.children(".container").append($rows);
      equalHeight();

      localizePage.localizeAll("listing"); //use full page localization to utilise the callback
    }

    function clearList() {
      $productList.children(".container").empty();
    }

    return {
      setJson: setJson,
      createList: createList,
      clearList: clearList,
      createProductRow: productRow,
      createProductColumn: productColumn,
      addGuideOptionsOrURL: addGuideOptionsOrURL,
    };
  })(jQuery);

  var getCategoryJson = function (category) {
    return jsonHome;
  };

  navBar.setURLLang(pageLanguage);

  //info : dtmTrack.trackPage(PAGENAME,CATEGORY,LANGUAGE);
  //var pageName = pageLanguage + ":" + getCurrentPageCategory() + ":landing";
  //dtmTrack.trackPage(pageName, getCurrentPageCategory(), pageLanguage);

  var init = function () {
    pageLanguage = urlControl.getURLParameter("lang") || "en";
    $productList = $("#product-list");

    omni.loading.show($productList);

    jsonUtility.loadProductListJsons(function (categoryJson) {
      // load jsons
      //call below methods when loading done
      var currentPageCategory = productList.getCurrentPageCategory(); //use full method name for unit test purpose
      jsonBusiness = categoryJson.business;
      jsonHome = categoryJson.home;
      showCookieConsent(pageLanguage, currentPageCategory);
      loadSupportedLanguages(categoryJson, pageLanguage);
      loadProducts.createList(
        getCategoryJson(currentPageCategory),
        currentPageCategory
      );
      omni.loading.remove();
    });
  };

  init();

  return {
    reInit: init,
    getCurrentPageCategory: getCurrentPageCategory,
    loadProducts: loadProducts,
    setPlatformsSelector: setPlatformsSelector,
    loadSupportedLanguages: loadSupportedLanguages,
    checkLanguageAvailability: checkLanguageAvailability,
  };
})(jQuery);

/***** Pop State is not being used here since it is unnecessary *****/
var pageHashChanged = $(window).on("hashchange", function () {
  window.location.reload();
});
